'use client';

import { GoogleTagManager } from '@next/third-parties/google';
import Script from 'next/script';
import React, { FC, useEffect, useState } from 'react';

// Same rule as robots.txt and middleware.ts: no tracking on local and stage hosts.
// Checked in the browser so the layout does not need request headers and pages stay static (ISR).
const isStageHost = (host: string) => host.includes('localhost') || host.includes('stage');

const Analytics: FC = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(!isStageHost(window.location.hostname));
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <>
      <GoogleTagManager gtmId="GTM-MDBHSJHJ" />
      <Script id="facebook-pixel" strategy="afterInteractive">
        {`!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1405367440668614');
    fbq('track', 'PageView');`}
      </Script>
      <Script id="linkedin-partner" strategy="afterInteractive">
        {`_linkedin_partner_id = "7342170";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);`}
      </Script>
      <Script id="linkedin-insight" strategy="afterInteractive">
        {`(function(l) {
      if (!l) {
        window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
        window.lintrk.q = [];
      }
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.type = "text/javascript";
      b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);
    })(window.lintrk);`}
      </Script>
    </>
  );
};

export default Analytics;
